import { ROUTES } from './paths'

export type SectionKey = 'home' | 'clients' | 'cars' | 'events'

/**
 * Режим раздела: menu — в меню, в маршрутах и по ссылкам с других страниц; direct — только
 * по прямому URL, в интерфейсе на него нет ни пункта меню, ни ссылок; off — раздела нет
 * ни в меню, ни в маршрутах. Код страницы остаётся в любом режиме.
 */
export type SectionMode = 'menu' | 'direct' | 'off'

/**
 * «Поток посетителей» в меню с 18.09.2026: появились /queues, /queues/history и данные в /visitors. «Поток автомобилей» в меню
 * с 17.09.2026 (реальные /plates/*); с «Главной» в него ведёт карточка «Автомобили» (ТЗ п. 9).
 */
export const SECTIONS: Record<SectionKey, SectionMode> = {
  home: 'menu',
  clients: 'menu',
  cars: 'menu',
  events: 'menu',
}

const SECTION_KEYS = Object.keys(SECTIONS) as SectionKey[]

/** У раздела есть маршрут, даже если его нет в меню. */
export const isSectionEnabled = (key: SectionKey): boolean => SECTIONS[key] !== 'off'

/** Разделы с маршрутами. */
export const ENABLED_SECTIONS = SECTION_KEYS.filter(isSectionEnabled)

/** Раздел в меню — только на такие ведут ссылки с других страниц (например, с «Главной»). */
export const isSectionInMenu = (key: SectionKey): boolean => SECTIONS[key] === 'menu'

/** Разделы в боковом меню. */
export const NAV_SECTIONS = SECTION_KEYS.filter(isSectionInMenu)

/** Куда ведёт корень сайта и редирект после входа — первый раздел из меню. */
export const DEFAULT_ROUTE: string = ROUTES[NAV_SECTIONS[0] ?? 'events']
